

          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            /* eslint-disable prettier/prettier */
/**
 * @type {import("vue/types/index").Vue}
 */
const TheVue = require("vue/dist/vue.js");
TheVue.config.productionTip = false;
TheVue.config.devtools = false;

const img = require("../assets/online-screen-recorder/recordscreenonline/tip-icon.svg");
const successImg = require("../assets/online-screen-recorder/recordscreenonline/light-tip-success.svg");
const confirmDialogKey = "confirm-dialog";
const getVipFormDialogKey = "get-vip-form-dialog";
const toastDialogKey = "toast-dialog";
const topBannerKey = "top-banner";
const audioToolsKey = "audio-tools-key";
const playBannerKey = "play-banner-key";
const audioDownloadDialogKey = "audio-download-dialog-key";

const toastImg = require("../assets/online-screen-recorder/recordscreenonline/light-tip.svg");
const toastSuccessImg = require("../assets/online-screen-recorder/recordscreenonline/light-success-tip.svg");

const box = document.querySelector("#onlineScreenBox");
TheVue.component(confirmDialogKey, {
  props: ["title", "subtitle", "leftText", "rightText", "successIcon"],
  template: `
    <div class="tip-dialog-common cloud-storage-limit flex">
    <div class="cloud-limit-content dialog-content-common">
      <div class="go-back-icon" style="background-image: none;">
        <img :src="successIcon?successImgUrl:imgUrl" alt="">
      </div>
      <div class="close" @click="clickClose"></div>
      <div class="cloud-limit-title">
        {{ title }}
        <div class="subtitle">{{ subtitle }}</div>
      </div>
      <div class="cloud-limit-btns">
        <div class="btn-common deep-btn" @click="clickLeft">{{ leftText }}</div>
        <div class="btn-common" @click="clickRight">{{ rightText }}</div>
      </div>
    </div>
    </div>
  `,
  data() {
    return {
      imgUrl: img,
      successImgUrl: successImg,
    };
  },
  methods: {
    clickLeft() {
      this.$emit("clickLeft");
    },
    clickRight() {
      this.$emit("clickRight");
    },
    clickClose() {
      this.$emit("clickClose");
    },
  },
});

TheVue.component(getVipFormDialogKey, {
  props: ["userId"],
  template: `
    <div class="tip-dialog-common cloud-storage-limit flex">
    <div class="cloud-limit-content dialog-content-common form-dialog scale">
      <div class="close" @click="clickClose"></div>
      <div class="form-area">
        <div class="form-item">
          <div class="title">{{ tr('user_id') }}</div>
          <input type="text" class="form-item-input user-id-input" :value="userId" readonly>
        </div>
        <div class="form-item">
          <div class="required title">{{ tr('google_name') }}</div>
          <input
            type="text"
            class="form-item-input nickname-input"
            v-model="googleNickname"
            :placeholder="tr('google_placeholder')"
            @blur="checkForm"
          >
          <div class="notice-required" :class="{active:enableNickRequired}">{{ tr('required') }}</div>
        </div>
        <div class="form-item">
          <div class="required title">{{ tr('review_content') }}</div>
          <textarea
            class="form-item-input review-content-area"
            v-model="reviewContent"
            :placeholder="tr('review_placeholder')"
            @blur="checkForm"
          ></textarea>
          <div class="notice-required" :class="{active:enableReviewRequired}">{{ tr('required') }}</div>
        </div>
      </div>
      <div class="cloud-limit-btns flex-center">
        <div class="btn-common" @click="clickRight">{{ tr('submit') }}</div>
      </div>
    </div>
    </div>
  `,
  data() {
    return {
      googleNickname: "",
      reviewContent: "",
      enableNickRequired: false,
      enableReviewRequired: false,
    };
  },
  methods: {
    clickClose() {
      this.$emit("clickClose");
    },
    clickRight() {
      if (this.checkForm()) {
        this.$emit("clickRight", {
          name: this.googleNickname,
          content: this.reviewContent,
        });
      }
    },
    checkForm() {
      this.enableNickRequired = !this.googleNickname;
      this.enableReviewRequired = !this.reviewContent;
      return (
        this.enableNickRequired === false && this.enableReviewRequired === false
      );
    },
    tr(key) {
      return trans(key);
    },
  },
});

TheVue.component(toastDialogKey, {
  props: ["msg", "successIcon"],
  template: `
    <div class="light-top-tip" style="z-index: 2011">
    <div class="tip-img" style="background-image: none">
      <img :src="successIcon?toastSuccessUrl:toastImg" alt="">
    </div>
    <div class="tip-word">{{ msg }}</div>
    </div>
  `,
  data() {
    return {
      toastSuccessUrl: toastSuccessImg,
      toastImg: toastImg,
    };
  },
});

TheVue.component(topBannerKey, {
  template: `
    <div class="top-banner" id="top-banner-id" :style="{height:height}">
      <a class="banner-title" target="_blank" :href="getUrl()">
        <div class="banner-down" id="top-banner-close-id" @click="handleClose"></div>
      </a>
    </div>
  `,
  data() {
    return {
      height: null
    };
  },
  methods: {
    handleClose(ev) {
      ev.stopPropagation();
      ev.preventDefault();
      this.height = "0px";
    },
    getUrl() {
      const langMap = new Map([["ar", "en"], ["el", "en"], ["cs", "cz"], ["ja", "jp"], ["da", "dk"], ["sv", "se"], ["kr", "en"]]);
      const lang = langMap.get(window.apower.lang) || window.apower.lang;
      const langCode = langMap.get(window.apower.lang) || lang;
      const isZh = window.apower.lang === 'zh'
      const isScreen = Boolean(document.querySelector('#recordOnlineBtn'))
      const isAudio = Boolean(document.querySelector('#startRecordAudioOnline'))
      const isConverter = Boolean(document.querySelector('.start-video-converter'))
      const isCapture = Boolean(document.querySelector('.screenshot-launch'))
      const cnUrl = 'https://reccloud.cn'
      const comUrl = `https://reccloud.com/${langCode}`
      const screenApptype = '?apptype=chn-online-screen-recorder'
      const audioApptype = '?apptype=chn-online-audio-recorder'
      const converterApptype = '?apptype=chn-online-video-converter'
      const captureApptype = '?apptype=chn-online-screen-capture'
      if (isScreen) {
        return isZh ? cnUrl + screenApptype : comUrl + screenApptype
      }
      else if (isAudio) {
        return isZh ? cnUrl + audioApptype : comUrl + audioApptype
      }
      else if(isConverter) {
        return isZh ? cnUrl + converterApptype : comUrl + converterApptype
      }
      else if(isCapture) {
        return isZh ? cnUrl + captureApptype : comUrl + captureApptype
      }
      else {
        throw new Error("非法地址")
      }
    },
    t(key) {
      return trans(key);
    }
  }
});


TheVue.component(audioToolsKey, {
  template: `
    <div class="options-container" id="video-options">
      <div class="options-item chat-video" id="chat-video-id">ChatVideo</div>
      <div class="options-item speech-to-text" id="speech-to-text">转文字</div>
    </div>
  `,
  methods: {
    t(key) {
      return trans(key);
    }
  }
});

TheVue.component(playBannerKey, {
  template: `
  <div class="question-container">
    <div class="question-title">温馨提示</div>
    <div class="question-item list-item">下载后播放异常 </div>
    <div class="question-item list-item">长时间,高音质录制 </div>
    <div class="question-item list-item">音频编辑转换 </div>
    <div class="question-item">请下载客户端使用</div>
    <a class="more-download-btn" href="https://download.apowersoft.cn/down.php?softid=streamingaudiorecorder-display_template" target="_blank">
      <div class="more-download-icon">下载客户端<div class="down-icon"></div></div>
    </a>
  </div>
  `
});

TheVue.component(audioDownloadDialogKey, {
  template: `
  <div class="get-app-dialog tip-dialog-common" id="downloadVideoDialogId">
    <div class="get-app-content dialog-content-common download-dialog">
     <div class="close" id="closeDownloadDialog"></div>
     <div class="content">
        <p class="item">想直接本地录制?</p>
        <p class="item">想高音质录制?</p>
        <p class="item">想编辑音频文件?</p>
        <p class="item">想录制更多格式?</p>
     </div>
     <div class="notice">更多功能请前往下载应用</div>
     <div class="btn-common get-app" id="download-video-id">
        <a href="https://download.apowersoft.cn/down.php?softid=streamingaudiorecorder-display_template" target="_blank" class="download" id="download2" rel="nofollow">下载客户端</a>
        <div class="get-app-icon"></div>
        <div class="sale-tips"></div>
     </div>
    </div>
 </div>
 `
});

function showAudioDownloadAfterDialog() {
  const render = new TheVue({
    render(h) {
      return h(audioDownloadDialogKey);
    }
  });
  render.$mount();
  const el = render.$el
  const closeBtn = el.querySelector('#closeDownloadDialog')
  const downloadBtn = el.querySelector('#download-video-id')
  closeBtn.onclick = function() {
    el.remove()
  }
  downloadBtn.onclick = function() {
    el.remove()
  }
  document.body.appendChild(el);
}

function showTopBanner() {
  const container = document.querySelector("#top-banner-container-id");
  if (container) {
    const el = render(topBannerKey);
    container.replaceWith(el);
  }
}

/**
 *
 * 显示音频右侧工具栏
 * @param containerEl {HTMLElement|string}
 */
function injectAudioTools(containerEl) {
  if (typeof containerEl === "string") {
    containerEl = document.querySelector(containerEl);
  }
  if (containerEl) {
    const render = new TheVue({
      render(h) {
        return h(audioToolsKey);
      }
    });
    render.$mount();
    containerEl.replaceWith(render.$el);
  }
}

function injectPlayBanner(containerEl) {
  if (typeof containerEl === "string") {
    containerEl = document.querySelector(containerEl);
  }
  if (containerEl) {
    const render = new TheVue({
      render(h) {
        return h(playBannerKey);
      }
    });
    render.$mount();
    containerEl.replaceWith(render.$el);
  }
}
/**
 * 显示toast
 * @param msg {string}
 * @param successIcon {boolean}
 */
function showToast(msg, successIcon = false) {
  const el = render(toastDialogKey, {
    dialogProps: {
      msg,
      successIcon,
    },
  });
  box.appendChild(el);
  setTimeout(() => {
    el.classList.add("active");
    setTimeout(() => {
      el.remove();
    }, 2000);
  }, 100);
}

/**
 * 表单提交弹窗
 * @param  params {FormDialogProps}
 */
function showGetVipFormDialog(params) {
  showDialog(params, getVipFormDialogKey);
}

/**
 * 弹出确认弹窗 左右两个按钮
 * @param  params {ConfirmDialogProps}
 */
function showConfirmDialog(params) {
  showDialog(params, confirmDialogKey);
}

function showDialog(params, componentId) {
  function closeDialog() {
    div.remove();
    params?.on?.onDialogClose?.();
  }

  const div = document.createElement("div");
  box.appendChild(div);
  const el = render(componentId, {
    dialogProps: {
      ...params.dialogProps,
    },
    on: {
      clickLeft(...args) {
        params.on?.clickLeft?.(closeDialog, ...args);
      },
      clickRight(...args) {
        params.on?.clickRight?.(closeDialog, ...args);
      },
      clickClose(...args) {
        if (params?.on?.clickClose) {
          params.on?.clickClose?.(closeDialog, ...args);
        } else {
          closeDialog();
        }
      },
    },
  });
  div.appendChild(el);
}

/**
 * 获取组件的真实dom
 * @param component {string}
 * @param params {ConfirmDialogProps}
 */
function render(component, params = {}) {
  const render = new TheVue({
    render(h) {
      return h(component, {
        props: {
          ...params.dialogProps,
        },
        on: {
          ...params.on,
        },
      });
    },
  });
  render.$mount();
  return render.$el;
}

function trans(key) {
  const lang = document.documentElement.lang ?? "en";
  const langMap = {
    de: {
      freeVideoLimit:
        "Sie haben das Speicherlimit für # kostenlose Videos erreicht",
      "001184": "Auf VIP upgraden",
      goReview: "Bewerten Sie uns",
      storageFull: "Der Cloud-Speicher ist voll",
      review_vip:
        "Geben Sie eine 5-Sterne-Bewertung und erhalten Sie 7 Tage Cloud-Mitgliedschaft",
      review_success:
        "Kommentar abgeschlossen, bitte Kommentarinformationen eingeben, um VIP zu erhalten",
      get_vip: "VIP erhalten",
      retry_review: "Bewertung wiederholen",
      user_id: "Benutzer-ID",
      google_name: "Google-Kontoname",
      review_content: "Bewertungsinhalt",
      submit: "Absenden",
      required: "Pflichtfeld",
      google_placeholder: "Geben Sie den Google-Kontonamen ein",
      review_placeholder: "Geben Sie den Bewertungsinhalt ein",
      get_success: "VIP erfolgreich erhalten",
      no_repeat_vip: "VIP kann nicht wiederholt erhalten werden",
      bannerTitle: "AI-gesteuert, sicher und effizient",
      bannerDesc: "Brandneue Multimedia-Service-Plattform",
      bannerBtn: "Jetzt erleben"
    },
    en: {
      freeVideoLimit: "You have reached # free videos storage limit",
      "001184": "Upgrade to VIP",
      goReview: "Rate US",
      storageFull: "The cloud storage is full",
      review_vip: "Give a 5-star review and get 7 days of cloud membership",
      review_success:
        "Comment completed, please enter comment information to get VIP",
      get_vip: "Get VIP",
      retry_review: "Retry Review",
      user_id: "User ID",
      google_name: "Google Account Nickname",
      review_content: "Review Content",
      submit: "Submit",
      required: "Required",
      google_placeholder: "Please enter Google account nickname",
      review_placeholder: "Please enter review content",
      get_success: "Get VIP successful",
      no_repeat_vip: "VIP cannot be obtained repeatedly",
      bannerTitle: "AI-Powered，secure and efficient",
      bannerDesc: "Brand new multimedia Service Platform",
      bannerBtn: "Experience now"
    },
    es: {
      freeVideoLimit:
        "Ha alcanzado el límite de almacenamiento de # videos gratuitos",
      "001184": "HAZTE PREMIUM",
      goReview: "Califica aquí",
      storageFull: "El almacenamiento en la nube está lleno",
      review_vip:
        "De una reseña de 5 estrellas y obtenga 7 días de membresía en la nube",
      review_success:
        "Comentario completado, ingrese la información del comentario para obtener VIP",
      get_vip: "Obtener VIP",
      retry_review: "Reintentar reseña",
      user_id: "ID de usuario",
      google_name: "Apodo de la cuenta de Google",
      review_content: "Contenido de la reseña",
      submit: "Enviar",
      required: "Requerido",
      google_placeholder: "Ingrese el apodo de la cuenta de Google",
      review_placeholder: "Ingrese el contenido de la reseña",
      get_success: "Obtener VIP exitoso",
      no_repeat_vip: "No se puede obtener VIP repetidamente",
      bannerTitle: "Alimentado por IA, seguro y eficiente",
      bannerDesc: " Nueva plataforma de servicios multimedia",
      bannerBtn: "¡Experimenta ahora!"
    },
    fr: {
      freeVideoLimit:
        "vous avez atteint la limite de stockage de # vidéos gratuites",
      "001184": "Ouvrir un compte VIP",
      goReview: "Évaluez-nous",
      storageFull: "le stockage cloud est plein",
      review_vip:
        "Donnez une évaluation 5 étoiles et obtenez 7 jours d'adhésion au cloud",
      review_success:
        "Commentaire terminé, veuillez saisir les informations du commentaire pour obtenir le VIP",
      get_vip: "Obtenir le VIP",
      retry_review: "Réessayer l'évaluation",
      user_id: "Identifiant utilisateur",
      google_name: "Pseudonyme du compte Google",
      review_content: "Contenu de l'évaluation",
      submit: "Soumettre",
      required: "Requis",
      google_placeholder: "Veuillez entrer le pseudonyme du compte Google",
      review_placeholder: "Veuillez entrer le contenu de l'évaluation",
      get_success: "Obtention du VIP réussie",
      no_repeat_vip: "Le VIP ne peut pas être obtenu plusieurs fois",
      bannerTitle: "Alimenté par l'IA, sécurisé et efficace",
      bannerDesc: "Nouvelle plateforme de services multimédias",
      bannerBtn: "Essayez maintenant"
    },
    ja: {
      freeVideoLimit: "無料動画ストレージが#本の限界に達しました",
      "001184": "VIPにアップグレード",
      goReview: "評価する",
      storageFull: "クラウドストレージがいっぱいです",
      review_vip: "5つ星のレビューを書いて、クラウド会員7日間GET",
      user_id: "ユーザーID",
      google_name: "Googleアカウントのニックネーム",
      review_content: "レビュー内容",
      submit: "提出する",
      required: "必須",
      google_placeholder: "Googleアカウントのニックネームを入力してください",
      review_placeholder: "レビュー内容を入力してください",
      get_success: "VIPの取得に成功しました",
      no_repeat_vip: "VIPは繰り返し取得できません",
      review_success:
        "コメントが完了しました。VIPを取得するにはコメント情報を入力してください。",
      get_vip: "VIPを取得",
      retry_review: "レビューを再試行",
      bannerTitle: "AI搭載、安全で効率的",
      bannerDesc: "新しいマルチメディアサービスプラットフォーム",
      bannerBtn: "今すぐ体験"
    },
    pt: {
      freeVideoLimit:
        "Você atingiu o limite de armazenamento de vídeos gratuitos de #",
      "001184": "Tonar-se VIP",
      goReview: "Avalie-nos",
      storageFull: "O armazenamento em nuvem está cheio",
      review_vip:
        "Dê uma avaliação de 5 estrelas e ganhe 7 dias de associação em nuvem",
      review_success:
        "コメントが完了しました。VIPを取得するにはコメント情報を入力してください。",
      get_vip: "VIPを取得",
      retry_review: "レビューを再試行",
      user_id: "ID do usuário",
      google_name: "Apelido da conta do Google",
      review_content: "Conteúdo da avaliação",
      submit: "Enviar",
      required: "Obrigatório",
      google_placeholder: "Por favor, insira o apelido da conta do Google",
      review_placeholder: "Por favor, insira o conteúdo da avaliação",
      get_success: "Obtenção de VIP bem sucedida",
      no_repeat_vip: "O VIP não pode ser obtido repetidamente",
      bannerTitle: "Alimentado por IA, seguro e eficiente",
      bannerDesc: "Nova plataforma de serviço multimídia",
      bannerBtn: "Experimente agora"
    },
    tw: {
      freeVideoLimit: "雲端免費存儲視頻數已達上限#個",
      "001184": "開通VIP",
      goReview: "立即評價",
      storageFull: "云端存储空间已滿",
      review_vip: "給5星好評,送雲端7天體驗會員",
      review_success: "評論完成,請登錄評論信息獲取VIP",
      get_vip: "獲取VIP",
      retry_review: "重新評價",
      user_id: "使用者ID",
      google_name: "Google帳號暱稱",
      review_content: "評論內容",
      submit: "提交",
      required: "必填",
      google_placeholder: "請輸入Google帳號暱稱",
      review_placeholder: "請輸入評論內容",
      get_success: "獲取VIP成功",
      no_repeat_vip: "VIP無法重複獲取",
      bannerTitle: "AI智能，安全高效",
      bannerDesc: "嶄新多媒體服務平臺",
      bannerBtn: "立即體驗"
    },
    zh: {
      freeVideoLimit: "云端免费存储视频数已达上限#个",
      "001184": "开通VIP",
      goReview: "去评价",
      storageFull: "云端存储空间已满",
      review_vip: "给5星好评，送云端7天体验会员",
      review_success: "评论完成，请登记评论信息获取VIP",
      get_vip: "获取VIP",
      retry_review: "重新评价",
      user_id: "用户ID",
      google_name: "Google账号昵称",
      review_content: "评价内容",
      submit: "提交",
      required: "必填",
      google_placeholder: "请输入Google账号昵称",
      review_placeholder: "请输入评价内容",
      get_success: "获取VIP成功",
      no_repeat_vip: "不可重复获取VIP",
      bannerTitle: "AI智能，安全高效",
      bannerDesc: "全新音视频处理平台",
      bannerBtn: "立即体验",
    },
  };

  return langMap[lang][key];
}

module.exports = {
  showConfirmDialog,
  showGetVipFormDialog,
  trans,
  showToast,
  showTopBanner,
  injectAudioTools,
  injectPlayBanner,
  showAudioDownloadAfterDialog,
};

          })
        